(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("httpstatuscodes", [], factory);
	else if(typeof exports === 'object')
		exports["httpstatuscodes"] = factory();
	else
		root["httpstatuscodes"] = factory();
})(window, function() {
return 